import { useEffect } from "react";
import { useTheme } from "../providers/ThemeProvider";
import { getColorSchemes, applyCssVariablesToRoot } from "../lib/colors";

export default function ColorThemeProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { theme } = useTheme();

    useEffect(() => {
        if (!theme) return;

        const schemes = getColorSchemes();
        applyCssVariablesToRoot(schemes, theme);
    }, [theme]);

    return <>{children}</>;
}
